<template lang="pug">
  nav
    ul
      li.pull-left
        h1.header.shadow-text
          router-link(:to="{ path: '/'}") Trump&nbsp;
            abbr(title='For The Loss') FTL
      //- li.submission
      //-   router-link(:to="{ path: '/submission' }" title="Submit" class="shadow-text")
      //-     icon(name="pencil" scale="3" color="#333")
      li.media
        router-link(:to="{ path: '/latest' }" title="Hot Stove" class="shadow-text")
          icon(name="camera" scale="3" color="#333")
      li.comments
        router-link(:to="{ path: '/burnnn' }" title="Burn Notice" class="shadow-text")
          icon(name="fire" scale="3" color="#333")
    //-  li.about
    //-    router-link(:to="{ path: '/about' }" title="About" class="shadow-text")
    //-      icon(name="user-circle" scale="3" color="#333")
    //- header(v-if="pageName === 'Home'")
    //-   router-link(:to="{ path: '/'}")
    //-     | Trump&nbsp;
    //-     abbr(title='For The Loss') FTL
</template>

<script>
export default {
  name: 'nav',
  data () {
    return {
      pageName: this.$route.name
    }
  }
}
</script>

<style lang="stylus" scoped>
.pull-left
  @media screen and (min-width: 401px)
    margin-right auto

h1.header
  font-family 'Playfair Display', serif
  font-weight 600
  font-size: 2.9rem
  text-transform uppercase
  display inline-block
  margin: 0

nav
  // background-image url('/static/trump-pope.jpg')
  // background-repeat no-repeat
  // background-position 0 0
  // background-size cover
  // min-height 300px
  // width 100%
  // justify-content space-between
  // text-align: right
  display flex
  align-items flex-end
  margin-bottom 2rem
  font-size: 1.9rem
  border-bottom 2px dashed #0a0a0a
  // padding-bottom 1rem
  ul
    // background rgba(255, 255, 255, 0.3)
    display flex
    flex-direction horizontal
    align-items center
    justify-content space-between
    list-style-type none
    margin 0
    padding 0
    width 100%
    @media screen and (max-width: 400px)
      justify-content center
      flex-direction column
    @media screen and (min-width: 401px)
      padding 0 1rem
    li
      display inline-block
      margin 0 0.3rem
      padding 0.3rem 0
      a.router-link-active
        text-decoration none
      &.bullseye,
      &.fire
        padding 1em 0 0 0
</style>



// WEBPACK FOOTER //
// Nav.vue?7c9b68a4